// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".idbox[data-v-fb936132] {\n  width: 100vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 32vw;\n}\n.idbox .id[data-v-fb936132] {\n  margin-bottom: 2.66667vw;\n  color: #0D0D0D;\n  font-size: 17px;\n}\n.idbox .sub[data-v-fb936132] {\n  color: #878787;\n  font-size: 12px;\n}\n.box[data-v-fb936132] {\n  min-height: 100vh;\n}", ""]);
// Exports
module.exports = exports;
